import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import TagIcon from '@mui/icons-material/Tag';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { BooleanField, BooleanInput, Button, Create, CreateButton, DataProvider, Datagrid, Edit, EditButton, ExportButton, FilterButton, FormTab, List, RaRecord, SelectInput, Show, ShowActions, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, TopToolbar, useListContext, usePermissions, useRecordContext, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import DateFnsField from 'utils/react-admin/DateFnsField';
import FetchButton from 'utils/react-admin/FetchButton';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import { Permissions } from '../../ra-php-crud-api-auth';
import Volunteer from 'utils/GeneratedModels/Volunteer';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import { fetchDownload } from 'utils/fetchJson';
import { useState } from 'react';
import { _makeFilter } from 'ra-data-treeql';
export const CHOICES_VOLUNTEER_GENDER = [
  { id: 'Male', name: '男', },
  { id: 'Female', name: '女', },
];

export const CHOICES_VOLUNTEER_WORKING_STATUS = [
  { id: 'full_time', name: '全職', },
  { id: 'student', name: '學生', },
  { id: 'self_employed', name: '自僱', },
  { id: 'housewife', name: '家庭主婦', },
  { id: 'retirement', name: '退休', },
  { id: 'others', name: '其他', },
];

export const CHOICES_VOLUNTEER_FAITH = [
  { id: 'buddhism', name: '佛教', },
  { id: 'others', name: '其他', },
];

export const CHOICES_VOLUNTEER_EDUCATION = [
  { id: 'primary', name: '小學', },
  { id: 'middle', name: '中學', },
  { id: 'college', name: '大專或以上', },
  { id: 'others', name: '其他', },
];

// export const CHOICES_VOLUNTEER_EXPERIENCE = [
//   { id: 'hospital_visit', name: '醫院探訪', },
//   { id: 'visiting_homes', name: '安老院探訪', },
//   { id: 'center_cleaning', name: '中心值日', },
//   { id: 'others', name: '其他', },
// ];

export const CHOICES_VOLUNTEER_EMOTIONAL_DISORDER = [
  { id: 'Yes', name: '是', },
  { id: 'No', name: '否', },
];


export const CHOICES_VOLUNTEER_EMOTIONAL_STATUS = [
  { id: 'healed', name: '已痊癒', },
  { id: 'in_treatment', name: '治療中', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <TextInput source="reg_no" fullWidth />,
  <TextInput source="last_name" fullWidth />,
  <TextInput source="first_name" fullWidth />,
  <TextInput source="chinese_last_name" fullWidth />,
  <TextInput source="chinese_first_name" fullWidth />,
  <SelectInput source="gender" fullWidth choices={CHOICES_VOLUNTEER_GENDER} />,
  <TextInput source="year_birth" fullWidth />,
  <TextInput source="identity" fullWidth />,
  <SelectInput source="working_status" fullWidth choices={CHOICES_VOLUNTEER_WORKING_STATUS} />,
  <TextInput source="other_career" fullWidth />,
  <TextInput source="address" fullWidth />,
  <TextInput source="telephone" fullWidth />,
  <TextInput source="email" fullWidth />,
  <SelectInput source="faith" fullWidth choices={CHOICES_VOLUNTEER_FAITH} />,
  <TextInput source="other_faith" fullWidth />,
  <TextInput source="leading" fullWidth />,
  <SelectInput source="education" fullWidth choices={CHOICES_VOLUNTEER_EDUCATION} />,
  <TextInput source="other_education" fullWidth />,
  <BooleanInput source="language_cantonese" fullWidth />,
  <BooleanInput source="language_mandarin" fullWidth />,
  <BooleanInput source="language_english" fullWidth />,
  <BooleanInput source="others" fullWidth />,
  <TextInput source="other_language" fullWidth />,
  <BooleanInput source="skill_instrument" fullWidth />,
  <BooleanInput source="skill_translation" fullWidth />,
  <BooleanInput source="skill_computer" fullWidth />,
  <BooleanInput source="skill_photography" fullWidth />,
  <BooleanInput source="skill_drive" fullWidth />,
  <BooleanInput source="skill_others" fullWidth />,
  <TextInput source="other_skill" fullWidth />,
  <BooleanInput source="service_hospital_visit" fullWidth />,
  <BooleanInput source="service_visiting_homes" fullWidth />,
  <BooleanInput source="service_center_cleaning" fullWidth />,
  <BooleanInput source="service_photography" fullWidth />,
  <BooleanInput source="service_others" fullWidth />,
  <TextInput source="other_service" fullWidth />,
  // <SelectInput source="experience" fullWidth choices={CHOICES_VOLUNTEER_EXPERIENCE} />,
  <TextInput source="other_experience" fullWidth />,
  <BooleanInput source="disease_heart_disease" fullWidth />,
  <BooleanInput source="disease_hypertension" fullWidth />,
  <BooleanInput source="disease_epilepsy" fullWidth />,
  <BooleanInput source="disease_diabetes" fullWidth />,
  <BooleanInput source="disease_tuberculosis" fullWidth />,
  <BooleanInput source="disease_hepatitis" fullWidth />,
  <BooleanInput source="disease_others" fullWidth />,
  <TextInput source="other_disease" fullWidth />,
  <SelectInput source="emotional_disorder" fullWidth choices={CHOICES_VOLUNTEER_EMOTIONAL_DISORDER} />,
  <SelectInput source="emotional_status" fullWidth choices={CHOICES_VOLUNTEER_EMOTIONAL_STATUS} />,
  <TextInput source="contact_person" fullWidth />,
  <TextInput source="relationship" fullWidth />,
  <TextInput source="contact_person_tel" fullWidth />,
  <BooleanInput source="agreement_1" fullWidth />,
  <BooleanInput source="agreement_2" fullWidth />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateLastName: any[] = [];
const validateFirstName: any[] = [];
const validateChineseLastName: any[] = [];
const validateChineseFirstName: any[] = [];
const validateGender: any[] = [];
const validateYearBirth: any[] = [];
const validateIdentity: any[] = [];
const validateWorkingStatus: any[] = [];
const validateOtherCareer: any[] = [];
const validateAddress: any[] = [];
const validateFaith: any[] = [];
const validateOtherFaith: any[] = [];
const validateLeading: any[] = [];
const validateEducation: any[] = [];
const validateOtherEducation: any[] = [];
const validateOtherLanguage: any[] = [];
const validateOtherService: any[] = [];
const validateOtherExperience: any[] = [];
const validateOtherDisease: any[] = [];
const validateEmotionalDisorder: any[] = [];
const validateEmotionalStatus: any[] = [];
const validateContactPerson: any[] = [];
const validateRelationship: any[] = [];
const validateContactPersonTel: any[] = [];
const validateAgreement1: any[] = [];
const validateAgreement2: any[] = [];

const GenRegNoButton = () => {
  const record = useRecordContext();
  if (record.approved || null !== record.reg_no) {
    return null;
  }
  return <FetchButton label={"Gen"} startIcon={<TagIcon />} doRefresh={true} urlSlug={'gen-reg-no'} options={{ method: 'PUT' }} />
}
const SendRegNoButton = () => {
  const record = useRecordContext();
  if (!record.approved || null === record.reg_no || null === record.email) {
    return null;
  }
  return <FetchButton label={"Send"} startIcon={<MarkEmailReadIcon />} urlSlug={'send-email'} options={{ method: 'GET' }}
    confirmTitle={`Confirm to resend to ${record.email}?`}
    confirmContent={`An email with RegNo #${record.reg_no} will be sent.`}
  />
}


// const CHOICES_DONATION_PERSONAL_TEAM_BY_ID = Object.fromEntries(CHOICES_DONATION_PERSONAL_TEAM.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_GENDER_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_GENDER.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_WORKING_STATUS_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_WORKING_STATUS.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_FAITH_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_FAITH.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_EDUCATION_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_EDUCATION.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_EMOTIONAL_DISORDER_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_EMOTIONAL_DISORDER.map(r => [r.id, r.name]));
const CHOICES_VOLUNTEER_EMOTIONAL_STATUS_BY_ID = Object.fromEntries(CHOICES_VOLUNTEER_EMOTIONAL_STATUS.map(r => [r.id, r.name]));

const VolunteerXlsHtmlExporter = (jsonData: Array<RaRecord>, _fetchRelatedRecords: (data: RaRecord, field: string, resource: string) => Promise<RaRecord>, _dataProvider: DataProvider, resource?: string) => {
  console.log(jsonData);

  jsonData = jsonData.map((row) => {
    delete (row as any).id;
    delete row.createdBy;
    delete row.updatedBy;
    delete row.lang;

    row.passport_photo = row.image_fm ? row.image_fm.src.split('/').reverse()[0] : '';

    let languages = [];
    if (row.language_cantonese) { languages.push('粵語') }
    if (row.language_mandarin) { languages.push('普通話') }
    if (row.language_english) { languages.push('英文') }
    row.language = languages.join(',');

    let skills = [];
    if (row.skill_instrument) { skills.push('文書') }
    if (row.skill_translation) { skills.push('翻譯') }
    if (row.skill_computer) { skills.push('電腦') }
    if (row.skill_photography) { skills.push('攝影') }
    if (row.skill_drive) { skills.push('駕駛') }
    if (row.skill_others) { skills.push('其他') }
    row.skill = skills.join(',');

    let services = [];
    if (row.service_hospital_visit) { services.push('醫院探訪') }
    if (row.service_visiting_homes) { services.push('安老院探訪') }
    if (row.service_center_cleaning) { services.push('中心值日') }
    if (row.service_photography) { services.push('攝影') }
    if (row.service_others) { services.push('其他') }
    row.service = services.join(',');

    let diseases = [];
    if (row.disease_heart_disease) { diseases.push('心臟病') }
    if (row.disease_hypertension) { diseases.push('高血壓') }
    if (row.disease_epilepsy) { diseases.push('癲癇症') }
    if (row.disease_diabetes) { diseases.push('糖尿病') }
    if (row.disease_tuberculosis) { diseases.push('肺結核') }
    if (row.disease_hepatitis) { diseases.push('肝炎') }
    if (row.disease_others) { diseases.push('其他') }
    row.disease = diseases.join(',');

    let experiences = [];
    if (row.experience_hospital_visit) { experiences.push('醫院探訪') }
    if (row.experience_visiting_homes) { experiences.push('安老院探訪') }
    if (row.experience_center_cleaning) { experiences.push('中心值日') }
    if (row.experience_others) { experiences.push('其他') }
    row.experience = experiences.join(',');

    if (null !== row.gender && CHOICES_VOLUNTEER_GENDER_BY_ID[row.gender]) {
      row.gender = CHOICES_VOLUNTEER_GENDER_BY_ID[row.gender];
    }
    if (null !== row.working_status && CHOICES_VOLUNTEER_WORKING_STATUS_BY_ID[row.working_status]) {
      row.working_status = CHOICES_VOLUNTEER_WORKING_STATUS_BY_ID[row.working_status];
    }
    if (null !== row.faith && CHOICES_VOLUNTEER_FAITH_BY_ID[row.faith]) {
      row.faith = CHOICES_VOLUNTEER_FAITH_BY_ID[row.faith];
    }
    if (null !== row.education && CHOICES_VOLUNTEER_EDUCATION_BY_ID[row.education]) {
      row.education = CHOICES_VOLUNTEER_EDUCATION_BY_ID[row.education];
    }
    if (null !== row.emotional_disorder && CHOICES_VOLUNTEER_EMOTIONAL_DISORDER_BY_ID[row.emotional_disorder]) {
      row.emotional_disorder = CHOICES_VOLUNTEER_EMOTIONAL_DISORDER_BY_ID[row.emotional_disorder];
    }
    if (null !== row.emotional_status && CHOICES_VOLUNTEER_EMOTIONAL_STATUS_BY_ID[row.emotional_status]) {
      row.emotional_status = CHOICES_VOLUNTEER_EMOTIONAL_STATUS_BY_ID[row.emotional_status];
    }

    return row;
  });

  // console.log(jsonData);

  return XlsHtmlExporter<Volunteer>(jsonData, _fetchRelatedRecords, _dataProvider, resource, {
    cols: [
      { field: 'reg_no', label: 'Volunteer Number' },
      { field: 'approved', label: 'Approval	?' },
      { field: 'passport_photo', label: 'Password Photo' },
      { field: 'last_name', label: '英文姓氏' },
      { field: 'first_name', label: '英文名字' },
      { field: 'chinese_last_name', label: '中文姓氏' },
      { field: 'chinese_first_name', label: '中文名字' },
      { field: 'gender', label: 'Gender' },
      { field: 'year_birth', label: 'Year of Birth' },
      { field: 'identity', label: 'Identity (The English letter and the first 4 digits of the ID card number)' },
      { field: 'working_status', label: 'Working Status' },
      { field: 'career', label: 'Career' },
      { field: 'other_career', label: 'Other Career' },
      { field: 'address', label: 'Address' },
      { field: 'telephone', label: 'Telephone' },
      { field: 'email', label: 'Email' },
      { field: 'faith', label: 'Faith' },
      { field: 'other_faith', label: 'Other Faith' },
      { field: 'leading', label: 'Leading Master' },
      { field: 'education', label: 'Education Level' },
      { field: 'other_education', label: 'Other Education' },
      { field: 'language', label: 'Language' },
      { field: 'other_language', label: 'Other Language' },
      { field: 'skill', label: 'Skill' },
      { field: 'other_skill', label: 'Other Skill' },
      { field: 'service', label: 'Service' },
      { field: 'other_service', label: 'Other Service' },
      { field: 'experience', label: 'Experience' },
      { field: 'other_experience', label: 'Other Experience' },
      { field: 'disease', label: 'Disease' },
      { field: 'other_disease', label: 'Other Disease' },
      { field: 'emotional_disorder', label: 'Emotional Disorder' },
      { field: 'emotional_status', label: 'Suffering from Emotional Disorders' },
      { field: 'contact_person', label: 'Contact Person' },
      { field: 'relationship', label: 'Relationship' },
      { field: 'contact_person_tel', label: 'Contact Person Tel' },
    ],
    orderBy: [
      { field: 'reg_no', order: 'asc', nullFirst: false }
    ]
  });
}

const ZipImageButton = () => {
  const [loading, setLoading] = useState(false);
  const { isLoading, filterValues } = useListContext();
  const filters = _makeFilter('working_date', { filter: filterValues });
  const url = `/api/zip/volunteer?${filters}`;

  return (
    <Button
      onClick={() => {
        setLoading(true)
        fetchDownload(url).finally(() => { setLoading(false) })
      }}
      label="Zip"
      disabled={isLoading || loading}
    >
      <FolderZipIcon />
    </Button>
  )
}
const ListActions = () => {
  return (
    <TopToolbar>
      <FilterButton />
      <CreateButton />
      <ExportButton />
      <ZipImageButton />
    </TopToolbar>
  )
};

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'reg_no', order: 'DESC' }} exporter={VolunteerXlsHtmlExporter} actions={<ListActions />}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.reg_no} (#${record.id})`}
          secondaryText={record => `${record.chinese_last_name} ${record.chinese_first_name} ${record.first_name} ${record.last_name}`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <TextField source="reg_no" fullWidth />
            <BooleanField source="email_sent" fullWidth />
            <TextField source="last_name" fullWidth />
            <TextField source="first_name" fullWidth />
            <TextField source="chinese_last_name" fullWidth />
            <TextField source="chinese_first_name" fullWidth />
            <TextField source="telephone" fullWidth />
            <TextField source="email" fullWidth />
            <TextField source="gender" fullWidth />
            {/* <TextField source="working_status" fullWidth /> */}
            {/* <TextField source="faith" fullWidth /> */}
            {/* <TextField source="education" fullWidth /> */}
            {/* <BooleanField source="language_cantonese" fullWidth /> */}
            {/* <BooleanField source="language_mandarin" fullWidth /> */}
            {/* <BooleanField source="language_english" fullWidth /> */}
            {/* <BooleanField source="others" fullWidth /> */}
            {/* <BooleanField source="skill_instrument" fullWidth /> */}
            {/* <BooleanField source="skill_translation" fullWidth /> */}
            {/* <BooleanField source="skill_computer" fullWidth /> */}
            {/* <BooleanField source="skill_photography" fullWidth /> */}
            {/* <BooleanField source="skill_drive" fullWidth /> */}
            {/* <BooleanField source="skill_others" fullWidth /> */}
            {/* <BooleanField source="service_hospital_visit" fullWidth /> */}
            {/* <BooleanField source="service_visiting_homes" fullWidth /> */}
            {/* <BooleanField source="service_center_cleaning" fullWidth /> */}
            {/* <BooleanField source="service_photography" fullWidth /> */}
            {/* <BooleanField source="service_others" fullWidth /> */}
            {/* <TextField source="experience" fullWidth /> */}
            {/* <BooleanField source="disease_heart_disease" fullWidth /> */}
            {/* <BooleanField source="disease_hypertension" fullWidth /> */}
            {/* <BooleanField source="disease_epilepsy" fullWidth /> */}
            {/* <BooleanField source="disease_diabetes" fullWidth /> */}
            {/* <BooleanField source="disease_tuberculosis" fullWidth /> */}
            {/* <BooleanField source="disease_hepatitis" fullWidth /> */}
            {/* <BooleanField source="disease_others" fullWidth /> */}
            {/* <TextField source="emotional_disorder" fullWidth /> */}
            {/* <TextField source="emotional_status" fullWidth /> */}
            {/* <BooleanField source="agreement_1" fullWidth /> */}
            {/* <BooleanField source="agreement_2" fullWidth /> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
            <GenRegNoButton />
            <SendRegNoButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="reg_no" fullWidth />
        <TextField source="last_name" fullWidth />
        <TextField source="first_name" fullWidth />
        <TextField source="chinese_last_name" fullWidth />
        <TextField source="chinese_first_name" fullWidth />
        <TextField source="gender" fullWidth />
        <TextField source="year_birth" fullWidth />
        <TextField source="identity" fullWidth />
        <TextField source="working_status" fullWidth />
        <TextField source="other_career" fullWidth />
        <TextField source="address" fullWidth />
        <TextField source="telephone" fullWidth />,
        <TextField source="email" fullWidth />,
        <TextField source="faith" fullWidth />
        <TextField source="other_faith" fullWidth />
        <TextField source="leading" fullWidth />
        <TextField source="education" fullWidth />
        <TextField source="other_education" fullWidth />
        <BooleanField source="language_cantonese" fullWidth />
        <BooleanField source="language_mandarin" fullWidth />
        <BooleanField source="language_english" fullWidth />
        <BooleanField source="others" fullWidth />
        <TextField source="other_language" fullWidth />
        <BooleanField source="skill_instrument" fullWidth />
        <BooleanField source="skill_translation" fullWidth />
        <BooleanField source="skill_computer" fullWidth />
        <BooleanField source="skill_photography" fullWidth />
        <BooleanField source="skill_drive" fullWidth />
        <BooleanField source="skill_others" fullWidth />
        <TextField source="other_skill" fullWidth />
        <BooleanField source="service_hospital_visit" fullWidth />
        <BooleanField source="service_visiting_homes" fullWidth />
        <BooleanField source="service_center_cleaning" fullWidth />
        <BooleanField source="service_photography" fullWidth />
        <BooleanField source="service_others" fullWidth />
        <TextField source="other_service" fullWidth />
        {/* <TextField source="experience" fullWidth /> */}
        <TextField source="other_experience" fullWidth />
        <BooleanField source="disease_heart_disease" fullWidth />
        <BooleanField source="disease_hypertension" fullWidth />
        <BooleanField source="disease_epilepsy" fullWidth />
        <BooleanField source="disease_diabetes" fullWidth />
        <BooleanField source="disease_tuberculosis" fullWidth />
        <BooleanField source="disease_hepatitis" fullWidth />
        <BooleanField source="disease_others" fullWidth />
        <TextField source="other_disease" fullWidth />
        <TextField source="emotional_disorder" fullWidth />
        <TextField source="emotional_status" fullWidth />
        <TextField source="contact_person" fullWidth />
        <TextField source="relationship" fullWidth />
        <TextField source="contact_person_tel" fullWidth />
        <BooleanField source="agreement_1" fullWidth />
        <BooleanField source="agreement_2" fullWidth />
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  data.image_fm = ('string' === typeof data.image_fm) ? data.image_fm : (null === data.image_fm ? null : JSON.stringify(data.image_fm));;
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><TextInput source="reg_no" fullWidth validate={validateLastName} /></Grid>
          <Grid item xs={6}><BooleanInput source="approved" fullWidth /></Grid>
          <Grid item xs={4}><SelectInput source="gender" fullWidth choices={CHOICES_VOLUNTEER_GENDER} validate={validateGender} /></Grid>
          <Grid item xs={4}><TextInput source="year_birth" fullWidth validate={validateYearBirth} /></Grid>
          <Grid item xs={4}><TextInput source="identity" fullWidth validate={validateIdentity} /></Grid>

          <Grid item xs={3}><TextInput source="last_name" fullWidth validate={validateLastName} /></Grid>
          <Grid item xs={3}><TextInput source="first_name" fullWidth validate={validateFirstName} /></Grid>
          <Grid item xs={3}><TextInput source="chinese_last_name" fullWidth validate={validateChineseLastName} /></Grid>
          <Grid item xs={3}><TextInput source="chinese_first_name" fullWidth validate={validateChineseFirstName} /></Grid>

          <Grid item xs={6}><SelectInput source="working_status" fullWidth choices={CHOICES_VOLUNTEER_WORKING_STATUS} validate={validateWorkingStatus} /></Grid>
          <Grid item xs={6}><TextInput source="other_career" fullWidth validate={validateOtherCareer} /></Grid>

          <Grid item xs={12}><TextInput source="address" fullWidth validate={validateAddress} /></Grid>
          <Grid item xs={6}><TextInput source="telephone" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="email" fullWidth /></Grid>

          <Grid item xs={4}><SelectInput source="faith" fullWidth choices={CHOICES_VOLUNTEER_FAITH} validate={validateFaith} /></Grid>
          <Grid item xs={4}><TextInput source="other_faith" fullWidth validate={validateOtherFaith} /></Grid>
          <Grid item xs={4}><TextInput source="leading" fullWidth validate={validateLeading} /></Grid>

          <Grid item xs={6}><SelectInput source="education" fullWidth choices={CHOICES_VOLUNTEER_EDUCATION} validate={validateEducation} /></Grid>
          <Grid item xs={6}><TextInput source="other_education" fullWidth validate={validateOtherEducation} /></Grid>

          <Grid item xs={4}><BooleanInput source="language_cantonese" fullWidth /></Grid>
          <Grid item xs={4}><BooleanInput source="language_mandarin" fullWidth /></Grid>
          <Grid item xs={4}><BooleanInput source="language_english" fullWidth /></Grid>
          <Grid item xs={6}><BooleanInput source="others" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="other_language" fullWidth validate={validateOtherLanguage} /></Grid>

          <Grid item xs={12}>
            <div style={{ display: 'flex' }}>
              <BooleanInput source="skill_instrument" fullWidth />
              <BooleanInput source="skill_translation" fullWidth />
              <BooleanInput source="skill_computer" fullWidth />
              <BooleanInput source="skill_photography" fullWidth />
              <BooleanInput source="skill_drive" fullWidth />
            </div>
          </Grid>
          <Grid item xs={6}><BooleanInput source="skill_others" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="other_skill" fullWidth /></Grid>

          <Grid item xs={12}>
            <div style={{ display: 'flex' }}>
              <BooleanInput source="service_hospital_visit" fullWidth />
              <BooleanInput source="service_visiting_homes" fullWidth />
              <BooleanInput source="service_center_cleaning" fullWidth />
              <BooleanInput source="service_photography" fullWidth />
            </div>
          </Grid>
          <Grid item xs={6}><BooleanInput source="service_others" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="other_service" fullWidth validate={validateOtherService} /></Grid>

          {/* <Grid item xs={6}><SelectInput source="experience" fullWidth choices={CHOICES_VOLUNTEER_EXPERIENCE} validate={validateExperience} /></Grid> */}
          <Grid item xs={12}>
            <div style={{ display: 'flex' }}>
              <BooleanInput source="experience_hospital_visit" fullWidth />
              <BooleanInput source="experience_visiting_homes" fullWidth />
              <BooleanInput source="experience_center_cleaning" fullWidth />
            </div>
          </Grid>
          <Grid item xs={6}><BooleanInput source="experience_others" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="other_experience" fullWidth validate={validateOtherExperience} /></Grid>

          <Grid item xs={12}>
            <div style={{ display: 'flex' }}>
              <BooleanInput source="disease_heart_disease" fullWidth />
              <BooleanInput source="disease_hypertension" fullWidth />
              <BooleanInput source="disease_epilepsy" fullWidth />
              <BooleanInput source="disease_diabetes" fullWidth />
              <BooleanInput source="disease_tuberculosis" fullWidth />
              <BooleanInput source="disease_hepatitis" fullWidth />
            </div>
          </Grid>
          <Grid item xs={6}><BooleanInput source="disease_others" fullWidth /></Grid>
          <Grid item xs={6}><TextInput source="other_disease" fullWidth validate={validateOtherDisease} /></Grid>

          <Grid item xs={6}><SelectInput source="emotional_disorder" fullWidth choices={CHOICES_VOLUNTEER_EMOTIONAL_DISORDER} validate={validateEmotionalDisorder} /></Grid>
          <Grid item xs={6}><SelectInput source="emotional_status" fullWidth choices={CHOICES_VOLUNTEER_EMOTIONAL_STATUS} validate={validateEmotionalStatus} /></Grid>
          <Grid item xs={6}><TextInput source="contact_person" fullWidth validate={validateContactPerson} /></Grid>
          <Grid item xs={6}><TextInput source="relationship" fullWidth validate={validateRelationship} /></Grid>
          <Grid item xs={6}><TextInput source="contact_person_tel" fullWidth validate={validateContactPersonTel} /></Grid>
          <Grid item xs={6}><BooleanInput source="agreement_1" fullWidth validate={validateAgreement1} /></Grid>
          <Grid item xs={6}><BooleanInput source="agreement_2" fullWidth validate={validateAgreement2} /></Grid>
        </GridWrapper>
      </FormTab>

    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: VolunteerActivismIcon,
}

export default Resource;
